import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Lightning01 = function Lightning01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13 2 4.0934 12.6879c-.3488.4185-.5232.6278-.5258.8046a.5.5 0 0 0 .1856.3964c.1375.1111.41.1111.9548.1111H12l-1 8 8.9065-10.6879c.3488-.4185.5232-.6278.5259-.8046a.5.5 0 0 0-.1857-.3964C20.1092 10 19.8368 10 19.292 10H12z"
    })
  }));
};
export default Lightning01;